import { z } from 'zod';
import { isValidCpf, onlyDigits } from '../utils/masks';

function isValidOptionalEmail(value: string): boolean {
  return value === '' || z.email().safeParse(value).success;
}

function isValidPhone(value: string): boolean {
  const length = onlyDigits(value).length;
  return length === 10 || length === 11;
}

// Mesma regra do BFF (CreateTicketRequestDto): letras, espaço, apóstrofo, ponto e hífen, até 120.
// Construído com RegExp porque o tsconfig mira ES5, que não aceita a flag `u` em literal.
export const NAME_PATTERN = new RegExp("^[\\p{L}\\p{M}' .-]+$", 'u');
export const NAME_MAX_LENGTH = 120;

export const personalDataFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'Informe seu nome')
    .max(NAME_MAX_LENGTH, `Use até ${NAME_MAX_LENGTH} caracteres`)
    .regex(NAME_PATTERN, 'Use apenas letras, espaços, apóstrofo, ponto e hífen'),
  cpf: z.string().refine(isValidCpf, 'CPF inválido'),
  email: z.string().trim().refine(isValidOptionalEmail, 'E-mail inválido'),
  phone: z.string().refine(isValidPhone, 'Telefone inválido'),
});

export type PersonalDataFormValues = z.infer<typeof personalDataFormSchema>;
